module.exports = __webpack_public_path__ + "media/GoxPuntos.26a31d78.mp4";